


















































import Vue from 'vue';
import { Acompanhamento } from '../../../../back/src/types';

import TheGestacoesTabelaNascidos from '../../components/gestacoes/TheGestacoesTabelaNascidos.vue';

export default Vue.extend({
  name: 'GestacoesNascidos',
  components: {
    TheGestacoesTabelaNascidos,
  },
  data: () => ({
    tab: 0,
    Acompanhamento,
  }),
});
